// extracted by mini-css-extract-plugin
export default {"customer-report-container":"entity_customer-report-container__cdAbO"};